<template>
  <div class="desk-frame">
    <!-- Top bar -->
    <div class="head_row_calander relative bg--white flex no_mobile">
      <a
        class="head-link-blue head-link-back flex"
        @click="goBack"
        href="javascript:void(0);"
      >
        <img src="/assets/img/svg/arrow_r.svg" />
        חזרה
      </a>
      <div class="title title--40 no-marge tx--blue2 title-mid">עריכת תור</div>
      <div class="flex">
        <a
          class="head-link-blue flex"
          v-if="!isAppointmentPassed"
          @click.prevent="cancelPop"
          href="javascript:void(0);"
          ><img src="/assets/img/svg/trash.svg" />ביטול תור</a
        >
        <a
          class="bt_blue bt-has"
          @click.prevent="saveAppSetTime"
          href="javascript:void(0);"
          ><img src="/assets/img/svg/saved.svg" />שמירה</a
        >
      </div>
    </div>
    <menu-desktop class="no_mobile" />

    <section
      class="
        mobile_add_new_head
        bg--blue
        tx--bege
        center
        flex flex--content--center
        relative
      "
    >
      <div class="title">עריכת תור</div>
      <a
        class="m_bt_head head_go_back flex m-flex--center is-svg-w"
        @click.prevent="goBack"
      >
        <ArrowBackSvgMobile />
      </a>
      <a class="m_bt_head head_save" @click.prevent="saveApp">שמירה</a>
    </section>

    <!-- Stage buttons -->
    <div class="edit_app_tabs bg--white no_mobile">
      <div class="edit_app_tabs_in relative center flex">
        <a
          href="javascript:void(0);"
          :class="{ 'active-tab': stage === 1 }"
          @click="checkStageIsValid(1)"
        >
          פרטים אישיים
        </a>
        <a
          href="javascript:void(0);"
          :class="{ 'active-tab': stage === 2, disabled: isAppointmentPassed }"
          @click="isAppointmentPassed ? () => {} : onStageTwo()"
        >
          מועד תור
        </a>
        <a
          href="javascript:void(0);"
          :class="{ 'active-tab': stage === 3 }"
          @click="checkStageIsValid(3)"
        >
          מסמכים והערות
        </a>
        <div class="my-tabs-active ease"></div>
      </div>
    </div>

    <!-- Stage 1 - details -->
    <ValidationObserver ref="newAppointmentForm">
      <form name="appointmentForm" v-if="appointment" autocomplete="off">
        <section class="add_new_inner desk-bg--white edit_app_tab_main">
          <div class="edit_app_info flex flex--top desk-hide">
            <div class="edit_app_info1">
              {{ appointment.firstName + " " + appointment.lastName }}<br />ת.ז.
              {{ appointment.passport }}
            </div>
            <div
              class="edit_app_info2 center"
              v-if="appointment.arrival_status.includes('approved')"
            >
              <span class="ok-green"></span>אישור הגעה
            </div>
          </div>

          <div
            v-show="!isAppointmentPassed"
            class="inner_group bg--white desk-hide"
          >
            <div class="add_new_row flex">
              <div class="add_new_row_col1">מועד*</div>
              <div class="add_new_row_col2">
                <div class="">
                  {{
                    $moment(appointment.start_datetime).format(
                      "DD/MM/YY , HH:mm  "
                    )
                  }}
                </div>
                <router-link class="date_choose" :to="{ name: 'time-update' }"
                  >עדכון</router-link
                >
              </div>
            </div>
            <div
              v-show="stage === 1 || isMobile"
              class="add_new_row flex desk-hide"
              style="min-height: 60px;"
            >
              <div class="add_new_row_col1">סוג תור*</div>
              <div v-if="filteredBlocks.length" class="add_new_row_col2">
                <validation-provider
                  name="type"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <select2
                      name="type"
                      v-model="appointment.appointment_type"
                      :isAppType="true"
                    >
                      <option
                        v-for="block in filteredBlocks"
                        :key="block"
                        :value="block"
                      >
                        {{ block }}
                      </option>
                    </select2>
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
              <div v-else class="add_new_row_col2">
                <vue-loaders-ball-clip-rotate
                  color="black"
                  scale="1.0"
                  style="position: relative; top:5px;"
                ></vue-loaders-ball-clip-rotate>
              </div>
            </div>
            <div
              v-show="stage === 1 || isMobile"
              class="add_new_row flex desk-hide"
            >
              <div class="add_new_row_col1">עלות התור</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="fee"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <div class="edit-fee">
                      <div class="fee-wrapper">
                        <input
                          dir="ltr"
                          ref="fee"
                          :class="{ 'no-events': !isEditFee }"
                          type="number"
                          name="fee"
                          min="0"
                          @keypress="numbersOnly($event)"
                          v-model="computedFee"
                          autocomplete="off"
                          :rules="{
                            required: true,
                            numeric: true,
                            feeRegex: /^[0-9]*$/
                          }"
                        />
                        <span>₪</span>
                      </div>
                      <span class="edit-btn">
                        <svg
                          @click="editFee"
                          v-if="!isEditFee"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pencil-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                          />
                        </svg>
                        <svg
                          @click="approveFee"
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-check-lg"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                          />
                        </svg>
                      </span>
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>

          <div
            v-show="stage === 1 || isMobile"
            class="inner_group bg--white desk_inner_width desk-flex desk-flex--top desk-flex--start"
          >
            <div
              v-if="appointment && !isMobile"
              class="add_new_row flex no_mobile"
            >
              <div class="add_new_row_col1 ">שם פרטי*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="firstName"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      type="text"
                      name="firstName"
                      v-model="appointment.firstName"
                      autocomplete="off"
                    />
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <div v-if="!isMobile" class="add_new_row flex no_mobile">
              <div class="add_new_row_col1 ">שם משפחה*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="lastName"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      type="text"
                      name="lastName"
                      v-model="appointment.lastName"
                      autocomplete="off"
                    />
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <div v-if="!isMobile" class="add_new_row flex no_mobile">
              <div class="add_new_row_col1 ">סוג תור*</div>
              <div v-if="filteredBlocks.length" class="add_new_row_col2">
                <validation-provider
                  name="type"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="filter_select">
                    <select2
                      name="type"
                      v-model="appointment.appointment_type"
                      :isAppType="true"
                    >
                      <option
                        v-for="block in filteredBlocks"
                        :key="block"
                        :value="block"
                      >
                        {{ block }}
                      </option>
                    </select2>
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
              <div v-else class="add_new_row_col2">
                <div class="input-opacity">
                  <div style="background-color: #eeeeee;height: 80px;">
                    <vue-loaders-ball-clip-rotate
                      color="black"
                      scale="1.2"
                      style="position: relative;top: 26px; right: 43%;"
                    ></vue-loaders-ball-clip-rotate>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isMobile" class="add_new_row flex no_mobile">
              <div class="add_new_row_col1 ">ת.ז*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="passport"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    name="passport"
                    v-model="appointment.passport"
                    autocomplete="off"
                  />
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="add_new_row flex no_mobile">
              <div class="add_new_row_col1">עלות התור*</div>
              <div class="add_new_row_col2">
                <div class="input-opacity">
                  <validation-provider
                    name="fee"
                    mode="lazy"
                    :rules="{
                      required: true,
                      regex: /^[0-9]*$/
                    }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="number"
                      @keypress="numbersOnly($event)"
                      min="0"
                      name="fee"
                      v-model="computedFee"
                      autocomplete="off"
                    />
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">תאריך לידה*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="birth_date"
                  rules="required|birth_date"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity tx--right">
                    <input
                      id="birth_date"
                      type="text"
                      name="birth_date"
                      placeholder="dd/mm/yyyy"
                      v-mask="['##/##/####']"
                      v-model="appointment.birthDate"
                      autocomplete="off"
                    />
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">נייד*</div>
              <div class="add_new_row_col2">
                <div class="input-opacity">
                  <validation-provider
                    name="phone"
                    mode="lazy"
                    :rules="{
                      required: true,
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="tel"
                      name="phone"
                      v-model="appointment.phone"
                      autocomplete="off"
                    />
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">טלפון נוסף</div>
              <div class="add_new_row_col2">
                <div class="input-opacity">
                  <validation-provider
                    name="phone2"
                    mode="lazy"
                    :rules="{
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                    <input
                      type="tel"
                      name="phone2"
                      v-model="appointment.second_phone"
                      autocomplete="off"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">שפה מועדפת</div>
              <div class="add_new_row_col2">
                <div class="input-opacity">
                  <select2 name="lang" id="" v-model="appointment.language">
                    <option value="">בחירה</option>
                    <option value="עברית">עברית</option>
                    <option value="אנגלית">אנגלית</option>
                    <option value="רוסית">רוסית</option>
                    <option value="ערבית">ערבית</option>
                  </select2>
                </div>
              </div>
            </div>
            <div class="add_new_row flex">
              <label for="gender" class="add_new_row_col1">מגדר</label>
              <validation-provider
                class="add_new_row_col2"
                name="gender"
                v-slot="{ errors }"
              >
                <div class="input-opacity">
                  <select2 name="gender" dir="rtl" v-model="appointment.gender">
                    <option value="">בחר מין</option>
                    <option value="male">זכר</option>
                    <option value="female">נקבה</option>
                  </select2>
                </div>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="add_new_row flex">
              <label for="email" class="email-label add_new_row_col1 "
                >אימייל</label
              >
              <div class="email-wrapper add_new_row_col2">
                <validation-provider
                  name="email"
                  :rules="{
                    emailRegex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                  }"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      id="email"
                      type="text"
                      name="email"
                      v-model="appointment.email"
                      autocomplete="off"
                    />
                  </div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <!-- OLD Approve arrival button -->
          </div>
          <!-- END stage 1 - details -->

          <!-- Stage 2- Appointment time -->
          <div
            v-if="filteredBlocks && filteredBlocks.length"
            class="no_mobile"
            v-show="stage === 2 || isMobile"
          >
            <time-update :isValid="checkValidTime" />
          </div>

          <!-- Stage 3 - Docs and comments -->
          <div class="wrap-stage-3" v-show="stage === 3 || isMobile">
            <div class="inner_group bg--white step-4-docs-group">
              <div class="add_new_row_col1 w-100">
                מסמכים מצורפים (ניתן להוסיף מסמך בסיומת pdf, jpg, png)
              </div>
              <div class="add_new_row_docs flex flex--start svg-block">
                <a
                  class="file_item relative flex"
                  :key="index"
                  v-for="(document, index) in documents"
                  @click.prevent="getDoc(document.path, document.name)"
                >
                  <img class="file-doc-ic" src="/assets/img/svg/file-doc.svg" />
                  <span class="tx_file block">{{ document.name }}</span>
                </a>
                <div
                  class="bt_upload relative flex desk-block"
                  @click="addDocuments"
                >
                  <input type="text" />
                  <div class="ic-upload ease">
                    <UploadSvg />
                  </div>
                  <div class="tx_file ease">הוספת מסמך</div>
                </div>
              </div>
            </div>
            <div class="inner_group bg--white step-4-docs-group">
              <div class="add_new_row flex desk-no-pad desk-w-100">
                <div class="add_new_row_col1 w-100">
                  הערות לתצוגה ברשימת התורים (לשימוש המרפאה)
                </div>
                <div class="input_area_opcity add-border">
                  <textarea v-model="appointment.notes"></textarea>
                </div>
              </div>
            </div>
            <div class="inner_group bg--white step-4-docs-group">
              <div class="add_new_row flex desk-no-pad desk-w-100">
                <div class="add_new_row_col1 w-100">
                  הערות נוספות לשימוש המרפאה (לא יוצגו למטופל)
                </div>
                <div class="input_area_opcity add-border">
                  <textarea v-model="appointment.insurance_note"></textarea>
                </div>
              </div>
            </div>
          </div>
          <a
            class="bt_cancel_app flex flex--content--center desk-hide mb--22"
            href="javascript:void(0)"
            v-if="!isAppointmentPassed"
            @click.prevent="cancelPop"
          >
            <TrashSvg /> ביטול תור
          </a>
        </section>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import UploadSvg from "@/assets/img/svg/upload.svg";
import TrashSvg from "@/assets/img/svg/trash.svg";
import ConfirmEditApp from "@/components/Popups/ConfirmEditApp";
import CancelPop from "@/components/Popups/CancelApp";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import TimeUpdate from "../../../views/TimeUpdate.vue";
import Error from "@/components/Popups/Error";
import AddDocuments from "@/components/Popups/AddDocuments";
import { mapMutations, mapGetters } from "vuex";
import ArrowBackSvgMobile from "../../../assets/img/svg/arrow_back.svg";
import { numbersOnly } from "../../../utilities/globals.js";
import { isDatePassed } from "../../../utilities/dates.js";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "EditApp",
  data() {
    return {
      checkValidTime: false,
      stage: 1,
      appointment: null,
      doctor: null,
      documents: [],
      blocks: [],
      filteredBlocks: [],
      appointmentToEdit: false,
      appointment_id: "",
      appointment_type: null,
      selected: null,
      isEditFee: false,
      splittedAppType: "",
      splittedAppInsurance: ""
    };
  },
  computed: {
    ...mapGetters(["appTimeEdit"]),
    isMobile() {
      return window && window.innerWidth < 1200;
    },
    computedFee: {
      get() {
        return this.appointment.fee === null ? 0 : this.appointment.fee;
      },
      set(newVal) {
        this.appointment.fee = newVal;
      }
    },
    isAppointmentPassed() {
      if (!this.appointment) return false;
      return this.isDatePassed(this.appointment.start_datetime);
    }
  },
  methods: {
    ...mapMutations(["SET_APPOINTMENT", "SET_BLOCK", "SET_APP_TIME_EDIT"]),
    numbersOnly,
    isDatePassed,
    addDocuments() {
      this.$modal.show(AddDocuments);
    },
    onStageTwo() {
      this.checkStageIsValid(2);
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    saveAppSetTime() {
      this.checkValidTime = true;
      setTimeout(() => this.saveApp(), 300);
    },
    async checkStageIsValid(stageNum) {
      const valid = await this.$refs.newAppointmentForm.validate();
      if (!valid || !this.appTimeEdit || !this.appTimeEdit.isValid) return;
      this.stage = stageNum;
    },
    async saveApp() {
      this.isEditFee = false;
      const valid = await this.$refs.newAppointmentForm.validate();
      if (!valid || !this.appTimeEdit || !this.appTimeEdit.isValid) return;
      localStorage.removeItem("appointmentLock");
      let datetime = this.$moment(this.appTimeEdit.date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      datetime += "T" + this.appTimeEdit.time + ":00";

      const birthDate = this.appointment.birthDate
        ? this.$moment(this.appointment.birthDate, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          )
        : null;

      let appointment = {
        block_id: this.appTimeEdit.block_id,
        datetime,
        appointment_id: this.$route.params.id,
        first_name: this.appointment.firstName,
        last_name: this.appointment.lastName,
        passport: this.appointment.passport,
        passport_type: this.appointment.passport_type,
        phone: this.appointment.phone,
        second_phone: this.appointment.second_phone
          ? this.appointment.second_phone
          : "",
        appointment_duration_min: this.appTimeEdit.duration,
        email: this.appointment.email,
        lang: this.appointment.language,
        gender: this.appointment.gender,
        birth_date: birthDate,
        notes: this.appointment.notes,
        general_notes: this.appointment.insurance_note,
        appointment_type: this.splittedAppType,
        cost_patient: this.appointment.fee,
        insurance: this.splittedAppInsurance,
        payment_method: this.appointment.payment_method,
        arrival_status: this.appointment.arrival_status
      };
      this.appointmentToEdit = appointment;

      let apiType;
      const orgAppDate = this.$moment(this.appointment.start_datetime).format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      const orgAppDuration = this.$moment(this.appointment.end_datetime).diff(
        this.$moment(this.appointment.start_datetime),
        "minutes"
      );

      if (
        orgAppDate === datetime &&
        orgAppDuration === this.appTimeEdit.duration
      ) {
        apiType = "update";
      } else {
        apiType = "update";
        // apiType = "schedule";
        const appDate = this.$moment(
          this.appTimeEdit.date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DDT");
        const appStart = appDate + this.appTimeEdit.time + ":00";
        const appEnd =
          appDate +
          this.$moment(this.appTimeEdit.time, "HH:mm")
            .add(this.appTimeEdit.duration, "m")
            .format("HH:mm:00");
        const appointmentTimeChange = {
          id: this.$route.params.id,
          start: appStart,
          end: appEnd,
          over_block_id: this.appTimeEdit.block_id,
          title: "appointment"
        };
        const res = await this.$API.setAppointementsDatetime([
          appointmentTimeChange
        ]);
        if (!res || res.status != "OK") {
          this.$modal.show(Error);
          return;
        }
      }

      const res = await this.$API.scheduleAppointment(
        this.appointmentToEdit,
        apiType
      );
      if (res.appointment_id || res === "approved") {
        this.appointment_id = res.appointment_id;
        this.$modal.show(ConfirmEditApp);
      } else {
        this.$modal.show(Error);
      }
    },
    cancelPop() {
      this.$modal.show(CancelPop, {
        appointment_id: this.$route.params.id,
        appDate: this.appointment.start_datetime.substring(0, 10)
      });
    },
    async getDoc(url, name) {
      if (!url || !url.includes("https://md-booking.hmc.co.il/")) return;
      try {
        const res = await this.$API.getDocApp(url);

        const link = document.createElement("a");
        link.href = res.message;
        link.download = name;

        const isMobile = window.innerWidth < 1200;
        if (isMobile && navigator.userAgent != "hmcAppUserAgent") {
          const response = await fetch(res.message);
          const blob = await response.blob();
          link.href = URL.createObjectURL(blob);
        }

        link.target = "_blank";
        link.click();
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    editFee() {
      this.isEditFee = true;
      this.$refs["fee"].focus();
    },
    approveFee() {
      if (this.$refs["fee"].value) this.isEditFee = false;
    },
    changeFeeByType(isInit = false) {
      const appNameSplitted = this.appointment.appointment_type.split("-");
      const findBlock = this.blocks.find(block => {
        const fullType = block.appointment_type + "-" + block.insurance;
        if (this.appointment.appointment_type == fullType) return true;
        return false;
      });
      if (findBlock) {
        this.splittedAppType = findBlock.appointment_type;
        this.splittedAppInsurance = findBlock.insurance;
        if (!isInit) {
          this.appointment.fee = findBlock.cost_patient
            ? findBlock.cost_patient
            : "0";
        }
      } else {
        if (appNameSplitted.length > 2) {
          this.splittedAppType = `${appNameSplitted[0]}-${appNameSplitted[1]}`;
          this.splittedAppInsurance = appNameSplitted[2];
        } else {
          this.splittedAppType = appNameSplitted[0];
          this.splittedAppInsurance = appNameSplitted[1];
        }
      }
    }
  },
  components: {
    UploadSvg,
    TrashSvg,
    MenuDesktop,
    TimeUpdate,
    ArrowBackSvgMobile
  },
  beforeMount() {
    this.$API
      .getAppointmentInfo(this.$route.params.id)
      .then(res => {
        this.appointment = res.message.appointment;
        this.appointment.birthDate = this.$moment(
          this.appointment.birthDate,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
        this.SET_APPOINTMENT(this.appointment);
        this.doctor = res.message.doctor;
        this.documents = res.message.documents;
        this.selected =
          this.appointment.arrival_status &&
          this.appointment.arrival_status.includes("approved")
            ? true
            : false;
        this.appointment.appointment_type =
          this.appointment.type + "-" + this.appointment.insurance;

        if (
          res.message.appointment.gender === "male" ||
          res.message.appointment.gender === "זכר"
        ) {
          this.appointment.gender = "male";
        } else if (
          res.message.appointment.gender === "female" ||
          res.message.appointment.gender === "נקבה"
        ) {
          this.appointment.gender = "female";
        } else {
          this.appointment.gender = "";
        }

        const startdate = this.$moment().format("YYYY-MM-DD");
        const endtdate = this.$moment(startdate, "YYYY-MM-DD")
          .add("0.5", "y")
          .format("YYYY-MM-DD");

        this.$API
          .getScheduleTable(this.doctor.id, startdate, endtdate)
          .then(res => {
            if (typeof res.data !== "undefined") {
              this.blocks = res.data;
              this.blocks.map(block => {
                if (block.appointment_type && block.insurance) {
                  let key = block.appointment_type + "-" + block.insurance;

                  if (!this.filteredBlocks.includes(key)) {
                    this.filteredBlocks.push(key);
                  }
                }
              });

              let block = [];

              for (const index in this.blocks) {
                if (
                  this.blocks[index].appointment_type &&
                  this.blocks[index].insurance
                ) {
                  block.push(this.blocks[index]);
                }
              }
              this.SET_BLOCK(block);
            }
          })
          .catch(e => {
            this.$modal.show(Error);
          });

        if (this.appointment) {
          let appointment = {
            block_id: this.appointment.surgery_block_id,
            datetime: this.$moment(this.appointment.start_datetime).format(
              "YYYY-MM-DTHH:mm:ss"
            ),
            appointment_id: this.appointment.id,
            first_name: this.appointment.firstName,
            last_name: this.appointment.lastName,
            passport: this.appointment.passport,
            phone: this.appointment.phone,
            second_phone: this.appointment.second_phone,
            appointment_duration_min: this.$moment(
              this.appointment.start_datetime
            ).diff(this.$moment(this.appointment.end_datetime), "minutes"),
            email: "",
            birth_date: this.appointment.birthDate,
            notes: this.appointment.notes,
            appointment_type: this.appointment.type,
            insurance: this.appointment.insurance,
            payment_method: this.appointment.payment_method
          };
          this.appointmentToEdit = appointment;
        }
        this.changeFeeByType(true);
      })
      .catch(e => {
        this.$modal.show(Error);
      });

    // Listen if select 2 appointment type changed & update fee
    this.$root.$on("changeFeeByType", () => {
      this.changeFeeByType();
    });
    // Listen if added documents & get appointment info
    this.$root.$on("getAppointmentInfo", () => {
      if (this.$route.name != "app-edit") return;
      this.$API.getAppointmentInfo(this.$route.params.id).then(res => {
        this.documents = res.message.documents;
      });
    });
  }
};
</script>

<style>
.edit-fee {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.85rem;
}
.edit-btn {
  cursor: pointer;
}
.no-events {
  pointer-events: none;
}
.fee-wrapper {
  display: flex;
  align-items: center;
}
#email {
  font-size: 20px;
}
.email-wrapper {
  width: 100%;
}
.email-label {
  width: 100%;
}
</style>
